export default {
  getGridStateByName: (state) => (userUuid, name) => {
    return state.grid[userUuid] ? state.grid[userUuid].hasOwnProperty(name) ? state.grid[userUuid][name] : {} : {}
  }
}
